/**
 * ShopDetail — shared formatters and constants.
 * Extracted from `pages/admin/ShopDetail.js`.
 */
export const initials = (name) =>
  (name || '').split(/\s+/).filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase() || '?';

export const fmtMoney = (n) => `£${Number(n || 0).toFixed(0)}`;

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const m = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')} · ${d.getDate()} ${m}`;
};

export const fmtISO = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const STATUS_PILL = (s) => {
  if (!s || s === 'cancelled') return { cls: 'gray', label: 'No active plan' };
  if (s === 'active' || s === 'trialing') return { cls: 'green', label: '● Live' };
  if (s === 'past_due') return { cls: 'amber', label: 'Past due' };
  return { cls: 'gray', label: s };
};
